import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaHistoricoCaixa } from "./components/TabelaHistoricoCaixa"

export function HistoricoCaixa() {
    return (
        <>
            <Cabecalho pagina="Histórico do Caixa" />
            <TabelaHistoricoCaixa />
        </>
    )
}
